import { baseURL } from './http.js';
import request from './request.js';
export default {
  userList: item => request(baseURL).post('leadApprovalConfig/list', item),
  createApprovalUser: item => request(baseURL).post('leadApprovalConfig/create', item),
  deleteApprovalUser: val => request(baseURL).post(`leadApprovalConfig/delete?id=${val}`),
}